import { render, staticRenderFns } from "./StoreInfoDetail.vue?vue&type=template&id=47996c76"
import script from "./StoreInfoDetail.vue?vue&type=script&lang=js"
export * from "./StoreInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoDetail.vue?vue&type=style&index=0&id=47996c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports